// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BillingDetails-billingTopLinkGrp-wEn8O {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    grid-gap: 12px;
}

.BillingDetails-billingIdCardTopRadius-roWmP {
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.BillingDetails-bookingIdCardWrapper-EGptP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 18px;
    grid-gap: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.BillingDetails-bookingIdInfoIdBox-bIQVY {
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    padding: 3px 12px;
    background: var(--opt-bg);
    border-radius: var(--radius-5);
    color: var(--common-primary-black-foreground);
    text-align: center;
}

.BillingDetails-priceDetailsFlex-DJZNY {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

.BillingDetails-promoCodeLsInfo-HK9w4 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.BillingDetails-promoCodeLsInfo-HK9w4 img {
    position: relative;
    top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/BillingDetails/BillingDetails.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAe;QAAf,eAAe;IACf,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ","sourcesContent":[".billingTopLinkGrp {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.billingIdCardTopRadius {\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.bookingIdCardWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    grid-gap: 18px;\n    flex-wrap: wrap;\n}\n\n.bookingIdInfoIdBox {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 700;\n    padding: 3px 12px;\n    background: var(--opt-bg);\n    border-radius: var(--radius-5);\n    color: var(--common-primary-black-foreground);\n    text-align: center;\n}\n\n.priceDetailsFlex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.promoCodeLsInfo {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    flex-grow: 1;\n    text-align: start;\n}\n\n.promoCodeLsInfo img {\n    position: relative;\n    top: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingTopLinkGrp": `BillingDetails-billingTopLinkGrp-wEn8O`,
	"billingIdCardTopRadius": `BillingDetails-billingIdCardTopRadius-roWmP`,
	"bookingIdCardWrapper": `BillingDetails-bookingIdCardWrapper-EGptP`,
	"bookingIdInfoIdBox": `BillingDetails-bookingIdInfoIdBox-bIQVY`,
	"priceDetailsFlex": `BillingDetails-priceDetailsFlex-DJZNY`,
	"promoCodeLsInfo": `BillingDetails-promoCodeLsInfo-HK9w4`
};
module.exports = ___CSS_LOADER_EXPORT___;
